import { render, staticRenderFns } from "./moreButton.vue?vue&type=template&id=5f795672&scoped=true"
import script from "./moreButton.vue?vue&type=script&lang=js"
export * from "./moreButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f795672",
  null
  
)

export default component.exports